module.exports = __webpack_public_path__ + "img/xb.a3edd73c.jpg";